import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

import {
  ITCSBalances,
  ITCSPayment,
  ITCSBalancesParams,
  ITCSPaymentForm,
  ITCSPaymentHistoryParams,
  ITCSBalancesResponse,
  ITCSPaymentResponse,
  ITCSPaymentHistoryResponse,
  ITCSTransactionBreakdown,
  ITCSTransactionBreakdownResponse
} from "../../utils/tcsSettlement.types";

/**
 * Fetch TCS balances for a period
 */
export const fetchTCSBalances = createAsyncThunk(
  'tcsSettlement/fetchBalances',
  async (params: ITCSBalancesParams): Promise<ITCSBalances> => {
    const response = await axios.get<ITCSBalancesResponse>(
      `/api/v1/tcs-settlement/balances`,
      { params }
    );
    return response.data.data;
  }
);

/**
 * Record TCS payment to government
 */
export const recordTCSPayment = createAsyncThunk(
  'tcsSettlement/recordPayment',
  async (paymentData: ITCSPaymentForm): Promise<ITCSPayment> => {
    const response = await axios.post<ITCSPaymentResponse>(
      `/api/v1/tcs-settlement/payment`,
      paymentData
    );
    return response.data.data;
  }
);

/**
 * Fetch TCS payment history
 */
export const fetchTCSPaymentHistory = createAsyncThunk(
  'tcsSettlement/fetchHistory',
  async (params?: ITCSPaymentHistoryParams): Promise<ITCSPayment[]> => {
    const response = await axios.get<ITCSPaymentHistoryResponse>(
      `/api/v1/tcs-settlement/payment-history`,
      { params }
    );
    return response.data.data;
  }
);

/**
 * Fetch single TCS payment by ID
 */
export const fetchTCSPaymentById = createAsyncThunk(
  'tcsSettlement/fetchPaymentById',
  async (paymentId: string): Promise<ITCSPayment> => {
    const response = await axios.get<ITCSPaymentResponse>(
      `/api/v1/tcs-settlement/payment/${paymentId}`
    );
    return response.data.data;
  }
);

/**
 * Fetch TCS transaction breakdown
 * Shows detailed list of all invoices that contributed to TCS amounts
 */
export const fetchTCSTransactionBreakdown = createAsyncThunk(
  'tcsSettlement/fetchTransactionBreakdown',
  async (params: ITCSBalancesParams): Promise<ITCSTransactionBreakdown> => {
    const response = await axios.get<ITCSTransactionBreakdownResponse>(
      `/api/v1/tcs-settlement/transactions`,
      { params }
    );
    return response.data.data;
  }
);
